import { css } from '@emotion/react'
import { gemVar, LineWeight, Spacing, ThemedColors } from '@opallabs/gem'

const rootClass = 'opal-calendar-date-navigator'
export const selectors = { root: rootClass } as const

export const root = css({
  alignItems: 'center',
  display: 'flex',
  gap: Spacing.XS,
})

/** Lapidary has no divider, and one rule is not worth a component. */
export const divider = css({
  // The same rule lapidary draws around the timescale tabs, so the two marks
  // in the header carry one weight.
  background: gemVar(ThemedColors.StrokeSecondary1),
  blockSize: Spacing.L,
  flex: 'none',
  inlineSize: LineWeight.Small,
})
